import { css } from '@emotion/react';
import { SpacingToken } from '@livechat/design-system-react-components';

export const signupLoaderStyles = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(${SpacingToken.Spacing3});
  padding: 0 var(${SpacingToken.Spacing5});
  height: 100vh;
`;
